
import React, { useEffect } from 'react';
import { useSettingsStore } from '@/store/api/settingsStore';
import { useAuth } from '@/contexts/AuthContext';
import { useUserStore } from '@/store/userStore';
import { useDashboardConfigStore } from '@/store/dashboardConfigStore';


// Convert to a React component function
export function SettingsInitializer() {
  const { fetchSettings } = useSettingsStore();
  const { fetchConfig } = useDashboardConfigStore();
  const { loading, user } = useAuth();
  const { gymId, isLoadingGymSwitch } = useUserStore();

  useEffect(() => {
    // ✅ Ne charger les settings qu'une fois l'utilisateur authentifié, gym sélectionné, et pas en train de switcher
    if (!loading && user && gymId && !isLoadingGymSwitch) {
      console.log('🔧 Loading settings for authenticated user:', user.id, 'gym:', gymId);
      fetchSettings().catch(console.error);
      
      // Charger la configuration du dashboard
      console.log('📊 Loading dashboard config for user:', user.id, 'gym:', gymId);
      fetchConfig(gymId, user.id).catch(console.error);
    }
  }, [loading, user, gymId, isLoadingGymSwitch, fetchSettings, fetchConfig]);
  
  return null;
}
